import React, { Component } from 'react';
import Header from 'parts/Header';
import Login from 'parts/login';
import Footer from 'parts/Footer';

export default class CompanyCharterPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <Login />
        <Footer />
      </>
    );
  }
}
